import _ from 'lodash';

/**
 * Launch Darkly is user-centric, so we're using JSON feature flags to enable flagging features by dispensary.
 * This helper checks if a dispensary has a feature enabled, or warns if the value is not an object.
 *
 * type DispensaryFeatureFlagValue {
 *   enabledForAll: Boolean
 *   enabledForDispensaries?: string[]
 *   variant: string
 * }
 *
 * @param {string} key
 * @param {(Object|boolean)} featureFlagValue
 * @param {string} dispensaryId
 * @param {boolean} defaultValue
 */
export default function evaluateDispensaryFeatureFlag(key, featureFlagValue, dispensaryId) {
  var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!_.isUndefined(featureFlagValue)) {
    if (_.isObject(featureFlagValue)) {
      if (featureFlagValue !== null && featureFlagValue !== void 0 && featureFlagValue.disabledForDispensaries && _.includes(featureFlagValue.disabledForDispensaries, dispensaryId)) {
        return false;
      }
      if (featureFlagValue !== null && featureFlagValue !== void 0 && featureFlagValue.enabledForAll) {
        return true;
      }
      if (!dispensaryId) {
        return defaultValue;
      }
      return _.includes(featureFlagValue === null || featureFlagValue === void 0 ? void 0 : featureFlagValue.enabledForDispensaries, dispensaryId);
    }
    if (_.isBoolean(featureFlagValue) || _.isString(featureFlagValue)) {
      return featureFlagValue;
    }
  }
  return defaultValue;
}

/**
 * Helper for checking flags in a class component
 *
 * @param {string} key: launch darkly key for feature flag
 * @param {Object} flags: launch darkly flags use withLDConsumer to access this via props (props.flags)
 * @param {string} dispensaryId
 * @param {boolean} defaultValue default returned if dispensaryId is not provided or proper LD response is not received
 */
export function flagIsEnabledForDispensary(key, flags, dispensaryId) {
  var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var featureFlagValue = flags[key];
  return evaluateDispensaryFeatureFlag(key, featureFlagValue, dispensaryId, defaultValue);
}